<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs12 sm12 md12 lg10 offset-lg1>
        <v-breadcrumbs
          :items="breadcrumbs"
          class="mb-4">
          <template v-slot:divider>
            <v-icon>chevron_right</v-icon>
          </template>
        </v-breadcrumbs>

        <!-- <div>
          <a href="/static/pdf.pdf" target="_blank">การเผยแพร่งานวิจัยและนวัตกรรม</a>
        </div> -->

        <v-select
          v-if="$route.params.faculty !== 'all-faculty'"
          v-model="facultySelected"
          :items="faculties"
          :menu-props="{ maxHeight: 'auto' }"
          label="คณะ"
          dense
          @change="facultyChange"></v-select>

        <v-select
          v-model="yearSelected"
          :items="years"
          :menu-props="{ maxHeight: 'auto' }"
          item-text="text"
          item-value="val"
          label="ปีงบประมาณ"
          dense
          @change="yearChange"></v-select>

        <v-data-table
          v-if="$route.params.faculty === 'all-faculty'"
          :headers="summaryHeaders"
          :items="summaryInfo"
          item-key="name"
          disable-initial-sort
          hide-actions
          class="elevation-1">
          <template v-slot:items="props">
            <tr>
              <td @click="facultyClick(props.item.name)" class="faculty-click">{{ props.item.name }}</td>
              <td class="text-xs-right">{{ props.item.projectsInFaculty }}</td>
              <td class="text-xs-right">{{ props.item.budgetInFaculty }}</td>
            </tr>
          </template>
        </v-data-table>

        <v-data-table
          v-if="projectInfo"
          :headers="projectHeaders"
          :items="projectInfo"
          :pagination.sync="pagination"
          item-key="name"
          disable-initial-sort
          hide-actions
          class="elevation-1">

          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column text-xs-' + (header.align || 'left'),
                  header.sortable === false ? 'pr-4' : (pagination.descending ? 'sortable desc' : 'sortable asc'),
                  header.value === pagination.sortBy ? 'active' : ''
                ]"
                :style="(header.minWidth ? 'min-width: ' + header.minWidth + ';' : '') + (header.width ? 'width:' + header.width + ';' : '')"
                @click="changeSort(header.value)">
                {{ header.text }}
                <v-icon small v-if="header.sortable !== false">arrow_upward</v-icon>
              </th>
            </tr>
          </template>

          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.fund_source }}</td>
              <td>{{ props.item.owner }}</td>
              <td>{{ props.item.period }}</td>
              <td class="text-xs-right">{{ numberFormat(props.item.budget) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import research from '@/data/research'

export default {
  name: 'ResearchInfo',

  data () {
    return {
      // data: research,
      pagination: {
        sortBy: 'period',
        descending: false,
        rowsPerPage: -1
      },
      facultySelected: 'all-faculty',
      yearSelected: '',
      summaryHeaders: [
        {
          text: 'คณะ/สถาบัน/สำนัก',
          align: 'left',
          // sortable: false,
          value: 'name'
        },
        {
          text: 'จำนวนโครงการ',
          align: 'right',
          value: 'projectsInFaculty'
        },
        {
          text: 'จำนวนเงิน',
          align: 'right',
          value: 'budgetInFaculty'
        }
      ],
      projectHeaders: [
        {
          text: 'ชื่อโครงการ',
          align: 'left',
          // sortable: false,
          value: 'name',
          minWidth: '250px'
        },
        {
          text: 'แหล่งทุน',
          align: 'left',
          // sortable: false,
          value: 'fund_source',
          minWidth: '135px'
        },
        {
          text: 'ชื่อคณะผู้วิจัย',
          align: 'left',
          // sortable: false,
          value: 'owner',
          minWidth: '200px'
        },
        {
          text: 'ระยะเวลา',
          align: 'center',
          // sortable: false,
          value: 'period',
          minWidth: '120px'
        },
        {
          text: 'งบประมาณ',
          align: 'right',
          // sortable: false,
          value: 'budget',
          minWidth: '130px'
        }
      ]
    }
  },

  created () {
    this.initData()
  },

  computed: {
    breadcrumbs () {
      let bc = []
      if (this.$route.params.faculty === 'all-faculty') {
        bc.push(...[
          {
            text: 'หน้าแรก',
            exact: true,
            to: { path: '/info' }
          },
          {
            text: 'ระบบสารสนเทศการจัดการงานวิจัยและนวัตกรรม',
            to: { path: '/info/all-faculty' }
          }
        ])
      } else {
        bc.push(...[
          {
            text: 'หน้าแรก',
            exact: true,
            to: { path: '/info' }
          },
          {
            text: 'ระบบสารสนเทศการจัดการงานวิจัยและนวัตกรรม',
            to: { path: '../all-faculty' }
          },
          {
            text: this.$route.params.faculty,
            disabled: true,
            href: ''
          }
        ])
      }

      return bc
    },

    faculties () {
      return Object.keys(research.faculty).map(key => research.faculty[key])
    },

    years () {
      let years = Object.keys(research.year).map(year => ({
        val: year,
        text: year + ' (1 ต.ค. ' + (year - 1) + ' - 30 ก.ย. ' + year + ')'
      }))

      if (this.$route.params.faculty === 'all-faculty') {
        years.splice(0, 0, {
          val: '',
          text: 'ทุกปี'
        })
      }

      return years
    },

    summaryInfo () {
      let projectSum = 0
      let budgetSum = 0
      let summaryInfo = Object.keys(research.faculty).reduce((filtered, key) => {
        if (this.$route.params.faculty === research.faculty[key] || this.$route.params.faculty === 'all-faculty') {
          let projectsInFaculty = this.projectsInFaculty(key, this.$route.params.year)
          let budgetInFaculty = this.budgetInFaculty(key, this.$route.params.year)

          projectSum += projectsInFaculty
          budgetSum += budgetInFaculty

          filtered.push({
            name: research.faculty[key],
            projectsInFaculty: this.numberFormat(projectsInFaculty, 0),
            budgetInFaculty: this.numberFormat(budgetInFaculty)
          })
        }

        return filtered
      }, [])

      // let projectSum = summaryInfo.reduce((total, obj) => total + (obj['projectsInFaculty'] || 0), 0)
      // let budgetSum = summaryInfo.reduce((total, obj) => total + (obj['budgetInFaculty'] || 0), 0)

      summaryInfo.push({
        name: 'รวม',
        projectsInFaculty: this.numberFormat(projectSum, 0),
        budgetInFaculty: this.numberFormat(budgetSum)
      })

      return summaryInfo
    },

    projectInfo () {
      let facultyKey = Object.keys(research.faculty).reduce((filtered, key) => {
        if (this.$route.params.faculty === research.faculty[key]) {
          filtered = key
        }

        return filtered
      }, null)

      if (facultyKey == null) {
        return false
      }

      // years
      let yearSelected = this.$route.params.year
      if (!yearSelected) {
        let yearSelect = Object.keys(research.year)
        yearSelected = yearSelect[0]
      }

      return research.year[yearSelected][facultyKey]
    }
  },

  watch: {
    '$route' (to, from) {
      // console.log(to, from)
      this.facultySelected = to.params.faculty || 'all-faculty'
      this.yearSelected = to.params.year || ''
    }
  },

  methods: {
    initData () {
      if (this.$route.params.faculty) {
        this.facultySelected = this.$route.params.faculty
      }

      if (this.$route.params.year) {
        this.yearSelected = this.$route.params.year
      } else if (this.$route.params.year) {
        this.yearSelected = this.$route.params.year
      } else if (!this.$route.params.year) {
        this.yearSelected = ''
      } else if (this.facultySelected !== 'all-faculty') {
        this.yearSelected = Object.keys(research.year)[0]
      }
    },

    numberFormat (val, precise = 2) {
      return (val / 1).toFixed(precise).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    projectsInFaculty (facultyCode, year) {
      if (year) {
        return (research.year[year] && research.year[year][facultyCode]) ? research.year[year][facultyCode].length : 0
      }

      let projectsCount = 0
      Object.keys(research.year).forEach(y => {
        projectsCount += research.year[y][facultyCode].length
      })

      return projectsCount
    },

    budgetInFaculty (facultyCode, year) {
      let budget = 0
      Object.keys(research.year).forEach(y => {
        if (!year || y === year) {
          research.year[y][facultyCode].forEach(project => {
            budget += project.budget
          })
        }
      })

      return budget
    },

    facultyClick (name) {
      if (name !== 'รวม') {
        this.facultySelected = name
        this.facultyChange()
      }
    },

    facultyChange () {
      let routeParams = { }
      routeParams['faculty'] = this.facultySelected
      if (this.yearSelected !== '') {
        routeParams['year'] = this.yearSelected
      } else {
        let yearSelect = Object.keys(research.year)
        routeParams['year'] = yearSelect[0]
        this.yearSelected = yearSelect[0]
      }

      this.$router.push({
        name: 'ResearchInfo',
        params: routeParams
      })
    },

    yearChange () {
      let routeParams = { }
      routeParams['faculty'] = this.$route.params.faculty
      if (this.yearSelected !== '') {
        routeParams['year'] = this.yearSelected
      }

      this.$router.push({
        name: 'ResearchInfo',
        params: routeParams
      })
    },

    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.faculty-click {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ResearchInfo.vue